var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Control } from 'react-redux-form';

const mapProps = {
  className: ({ fieldValue }) => {
    const _fieldValue = fieldValue.$form || fieldValue;
    return _fieldValue.submitFailed && !_fieldValue.valid ? 'has-error' : '';
  }
};

function controlComponent(className) {
  // eslint-disable-next-line react/prop-types
  return (props) => /*#__PURE__*/_jsx("div", { className: `${className} ${props.className}` }, void 0, props.children);
}

export class FormGroup extends Component {
  render() {
    if (this.props.model) {
      const className = `form-group ${this.props.className || ''}`;
      return /*#__PURE__*/(
        _jsx(Control.custom, {
          model: this.props.model,
          component: controlComponent(className),
          mapProps: mapProps }, void 0,

        this.props.children
        ));

    }

    return /*#__PURE__*/_jsx("div", { className: `form-group ${this.props.className}` }, void 0, this.props.children);
  }
}



FormGroup.defaultProps = {
  hasError: false,
  className: '',
  model: '',
  children: PropTypes.any
};








export default connect()(FormGroup);